<div class="report-footer" [class.d-none]="printOnly()" [class.d-print-block]="printOnly()">
  <div class="report-footer-content">
    @if (showPoweredBy()) {
      <div class="row">
        <div class="col">
          <ng-container *ngTemplateOutlet="contentTemplate" />
        </div>
      </div>
      <div class="col-auto ms-auto">
        Powered by
        <a rel="noopener noreferrer" target="_blank" href="https://cfp.nl">
          <img src="./assets/img/csr-logo-report.png" alt="CFP GREEN BUILDINGS" />
        </a>
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="contentTemplate" />
    }
  </div>
</div>

<ng-template #contentTemplate>
  <ng-content />
</ng-template>
